import { Alert } from "@sortera/react-components";
import type { LimitLock } from "./types.ts";
import { formatReset } from "./utils.ts";

/** Shown while the box is locked, so the person learns it before typing, not from a refusal. */
export function LimitNotice({ lock, className }: { lock: LimitLock; className?: string }) {
  if (!lock.locked) return null;
  return (
    <Alert variant="warning" className={className} title="Du har nått månadens gräns">
      {lock.resetsAt === null ? "Du kan skriva igen nästa månad." : `Du kan skriva igen den ${formatReset(lock.resetsAt)}.`}
    </Alert>
  );
}
